import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "view", "icon", "mode", "iconView", "onlyIcon", "className", "loading", "invert"];
import React from 'react';
import { cnBem } from '@carnica/utils';
import styles from "../styles.pcss";
import { getIconColor } from "../utils";
var cnButtonIcon = cnBem('button-icon', styles);
var getIconSize = function getIconSize(mode, view, onlyIcon) {
  if (mode === 'default') {
    return onlyIcon ? 'm' : 's';
  }
  return view === 'background' ? 'xs' : 's';
};
export var ButtonIcon = function ButtonIcon(_ref) {
  var disabled = _ref.disabled,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'primary' : _ref$view,
    Icon = _ref.icon,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    _ref$iconView = _ref.iconView,
    iconView = _ref$iconView === void 0 ? 'default' : _ref$iconView,
    onlyIcon = _ref.onlyIcon,
    className = _ref.className,
    loading = _ref.loading,
    invert = _ref.invert,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!Icon) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Icon, _extends({}, otherProps, {
    className: cnButtonIcon({
      view: iconView,
      loading: loading,
      invert: invert
    }, [className]),
    color: getIconColor({
      view: view,
      mode: mode,
      disabled: disabled,
      invert: invert
    }),
    iconClassName: cnButtonIcon('container'),
    size: getIconSize(mode, iconView, onlyIcon)
  }));
};